import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import InputMask from 'react-input-mask';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';


function EmpresaRegisterInfo(props) {
  const {
    empresa,
    setEmpresa,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
  } = props;
  const [razaoSocial, setrazaoSocial] = useState(props.empresa.razaoSocial);
  const [nomeFantasia, setnomeFantasia] = useState(props.empresa.nomeFantasia);
  const [cnpj, setCnpj] = useState(props.empresa.cnpj);
  const [email, setEmail] = useState(props.empresa.email);
  const [cnae, setCnae] = useState(props.empresa.cnae);
  const [inscricaoEstadual, setinscricaoEstadual] = useState(props.empresa.inscricaoEstadual);
  const [inscricaoMunicipal, setinscricaoMunicipal] = useState(props.empresa.inscricaoMunicipal);
  const [maskCpfCnpj] = useState('99.999.999/9999-99');
  const [maskCnae] = useState('9999-9/99');
  const [openDialogFinish, setOpenDialogFinish] = React.useState(false);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
  }


  function abrirDialogFinish (e) {
    setOpenDialogFinish(!openDialogFinish);
  }



  function errosForms() {
    setMessageSnack("Existem erros no formulário! Verifique e tente novamente");
    setTypeSnack('error');
    setShowMessageSnack(true);
  }

  function modificarValores(order, value){
    switch (order) {
      case 0:
        empresa.razaoSocial = value;
        setEmpresa(empresa);
        setrazaoSocial(value);
        break;
      case 1:
        empresa.nomeFantasia = value;
        setEmpresa(empresa);
        setnomeFantasia(value);
        break;
      case 2:
        empresa.email = value;
        setEmpresa(empresa);
        setEmail(value);
        break;
      case 3:
        empresa.cnpj = value;
        setEmpresa(empresa);
        setCnpj(value);
        break;
    }
    setEmpresa(empresa);
  }


  return (
    <div>
      <CardHeader
        subheader="Informe as seguintes informações da empresa"
        title="Empresa"
      />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Razão Social"
              helperText="Insira a razão social da empresa."
              margin="dense"
              name="razaoSocial"
              onChange={e => modificarValores(0, e.target.value)}
              value={empresa.razaoSocial}
              variant="outlined"
              validators={['required', 'minStringLength:3', 'maxStringLength:155']}
              errorMessages={['Informe a razão social!', 'Razão Social muito curta!', 'Razão Social muito longo!']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Nome Fantasia"
              helperText="Insira o nome fantasia da empresa!"
              margin="dense"
              name="nomeFantasia"
              onChange={e => modificarValores(1, e.target.value)}
              value={nomeFantasia}
              variant="outlined"
              validators={['required', 'minStringLength:3', 'maxStringLength:155']}
              errorMessages={['Informe o nome fantasia da empresa!', 'Nome fantasia muito curta!', 'Nome fantasia muito longo!']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Email"
              helperText="Insira o email da empresa!"
              margin="dense"
              name="email"
              onChange={e => modificarValores(2, e.target.value)}
              value={email}
              variant="outlined"
              validators={['required', 'isEmail']}
              errorMessages={['Informe o email da empresa!', 'Informe um email válido!']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >

            <InputMask
              mask={maskCpfCnpj}
              value={cnpj}
              onChange={e => modificarValores(3, e.target.value)}
            >
              {
                (inputProps) =>
                  <TextValidator
                    fullWidth
                    label="CNPJ"
                    margin="dense"
                    name="cnpj"
                    onChange={inputProps.onChange}
                    type="text"
                    variant="outlined"
                    helperText="Insira o CNPJ da empresa."
                    validators={['required']}
                    errorMessages={['Informe o CNPJ.']  }
                  />

              }
            </InputMask>
          </Grid>

        </Grid>
      </CardContent>
      <Divider />

    </div>
  );
};

EmpresaRegisterInfo.propTypes = {
  className: PropTypes.string,
  empresa: PropTypes.object.isRequired
};

export default EmpresaRegisterInfo;


